import type { ExternalAccountResource, OAuthStrategy, UserResource } from '@clerk/types'


export type SupportedOAuthProvider = 'apple' | 'google' | 'facebook'

export interface SupportedOAuthProviderConfig {
    label: string
    provider: SupportedOAuthProvider
    strategy: OAuthStrategy
    iconSrc?: string
    className?: string
}

export interface OAuthPublicMetadata {
    hasViewedExplainer: boolean
}

export const supportedOAuthProviders: SupportedOAuthProviderConfig[] = [
    {
        label: 'Apple',
        provider: 'apple',
        strategy: 'oauth_apple',
        iconSrc: '/icons/apple-logo-dark.svg',
        className: 'auth-sign-in-social-button-apple'
    },
    {
        label: 'Google',
        provider: 'google',
        strategy: 'oauth_google',
        iconSrc: '/icons/google-logo.png',
        className: 'auth-sign-in-social-button-google'
    },
    // {
    //     label: 'Facebook',
    //     provider: 'facebook',
    //     strategy: 'oauth_facebook',
    //     iconSrc: '/icons/facebook-logo.png',
    //     className: 'auth-sign-in-social-button-facebook'
    // },
]

export function getOAuthPublicMetadata(user?: Pick<UserResource, 'unsafeMetadata'> | null): OAuthPublicMetadata {
    const metadata = user?.unsafeMetadata?.oauth
    if (typeof metadata !== 'object' || metadata == null) {
        return {
            hasViewedExplainer: false
        }
    }

    const hasViewedExplainer = 'hasViewedExplainer' in metadata && metadata.hasViewedExplainer === true

    return {
        hasViewedExplainer
    }
}

export function getSupportedExternalAccounts(user?: Pick<UserResource, 'externalAccounts'> | null): ExternalAccountResource[] {
    const supportedProviders = new Set<SupportedOAuthProvider>(['apple', 'google', 'facebook'])
    return (user?.externalAccounts || []).filter((account) => (
        supportedProviders.has(account.provider as SupportedOAuthProvider)
        && account.verification?.status === 'verified'
    ))
}

export function countSupportedExternalAccounts(user?: Pick<UserResource, 'externalAccounts'> | null): number {
    return getSupportedExternalAccounts(user).length
}
